import React from "react";
import { Sparkles } from "lucide-react";

// Opens School Intelligence and asks a context-aware question about a specific
// pillar / chart / question. Renders nothing if the assistant isn't mounted —
// it simply dispatches an event the IntelligencePanel listens for.
export default function ExplainButton({ question, context, label = "Explain this", className = "" }) {
  const ask = (e) => {
    e?.stopPropagation?.();
    window.dispatchEvent(new CustomEvent("intel-ask", { detail: { question, context } }));
  };
  return (
    <button onClick={ask} data-testid="explain-this-btn"
      className={`inline-flex items-center gap-1 text-[11px] font-semibold text-indigo-600 hover:text-indigo-800 ${className}`}>
      <Sparkles className="h-3 w-3" /> {label}
    </button>
  );
}
